__webpack_require__.p = "https://admin.sdkstjosephlmj.sch.id/";